import { Col, Row } from 'antd';
import styled from 'styled-components';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import {
  boxShadow,
} from 'Utils/utilsStyle';
import { IsMobileSm } from 'Utils/UtilityFunctions';
import classNames from 'classnames';

const Wrapper = styled.div`
 box-shadow : ${boxShadow};
 background-color: transparent;
 border-radius: 12px;
 padding: 23px 24px;
 height: 662px;
 &.suspenseLoader {
  height: 600px;
 }
 .ant-pulse-triggers {
  height: 100%;
  .second-row-col {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
  }
}
`;
type Props = {
  loader?: boolean,
} & typeof defaultProps;

const defaultProps = {
  loader: false,
};

const SalesSigmaLeadershipBoardSkeleton = function SalesSigmaLeadershipBoardSkeleton(props: Props) {
  const { loader } = props;
  const smMob = IsMobileSm();
  return (
    <Wrapper className={classNames('pulse-wrapper', { suspenseLoader: loader })}>
      <div className="heading-inner-page mb-c-10">
        <SkeletonCustom height="40px" width={smMob ? '200px' : '300px'} diameter="10px" margin="0 13px 0 0" />
      </div>
      <Row className="ant-pulse-triggers">
        <Col span={24} className="first-row-col">
          {
            [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11].map(
              (val) => (
                <SkeletonCustom
                  height="22px"
                  width="calc(100% - 50px)"
                  diameter="0px"
                  margin="0px"
                  key={val}
                />
              ),
            )
          }
        </Col>
        <Col className="second-row-col">
          <SkeletonCustom height="40px" width={smMob ? '200px' : '300px'} diameter="10px" margin="0 0 15px 0" />
          <SkeletonCustom height="40px" width={smMob ? '200px' : '300px'} diameter="10px" margin="0 0 15px 0" />
        </Col>
      </Row>
    </Wrapper>
  );
};
export default SalesSigmaLeadershipBoardSkeleton;
SalesSigmaLeadershipBoardSkeleton.defaultProps = defaultProps;
